import type { PropType } from 'virtual-vue';
import type { DividerLayout } from './divider';

export const DEFAULT_DIVIDER_LAYOUT = 'horizontal';

/**
 * Component props
 */
export const props = {
  /**
   * 分割线类型
   * @default 'horizontal'
   */
  layout: {
    type: String as PropType<DividerLayout>,
    default: DEFAULT_DIVIDER_LAYOUT,
  },
};
